function setSessionStorageItem(key, state) {
    try {
        const item = JSON.stringify(state);
        globalThis.sessionStorage.setItem(key, item);
    } catch (err) {
        console.warn(`unable to set item with key: ${key} in sessionStorage`);
    }
}

export { setSessionStorageItem };
//# sourceMappingURL=set-session-storage-item.js.map
